<template>
  <div class="login-page">
    <main class="login-panel">
      <div class="login-brand">
        <i><Icon type="ios-pulse" /></i>
        <div>
          <b>上消化道早期筛查</b>
          <span>登录后查看检测进展和报告</span>
        </div>
      </div>

      <Form label-position="top" @submit.native.prevent>
        <FormItem label="账号或手机号">
          <Input
            v-model.trim="form.account"
            maxlength="30"
            autocomplete="username"
            placeholder="请输入账号或手机号"
            @on-enter="focusPassword"
          >
            <Icon slot="prefix" type="ios-person-outline" />
          </Input>
        </FormItem>
        <FormItem label="密码">
          <Input
            ref="passwordInput"
            v-model="form.password"
            :type="showPassword ? 'text' : 'password'"
            maxlength="30"
            autocomplete="current-password"
            placeholder="请输入密码"
            @on-enter="login"
          >
            <Icon slot="prefix" type="ios-lock-outline" />
            <Icon
              slot="suffix"
              :type="showPassword ? 'ios-eye-off-outline' : 'ios-eye-outline'"
              class="password-toggle"
              @click="showPassword = !showPassword"
            />
          </Input>
        </FormItem>
      </Form>

      <div v-if="errorMessage" class="login-error" role="alert">
        <Icon type="ios-information-circle-outline" />
        <span>{{ errorMessage }}</span>
      </div>

      <Button type="primary" long size="large" :loading="loading" @click="login">登录</Button>
    </main>
  </div>
</template>

<script>
import Qs from 'qs'
import sha1 from 'js-sha1'
import { setToken, setAuthMeta } from '../utils/auth'

export default {
  name: 'Login',
  data () {
    return {
      loading: false,
      showPassword: false,
      errorMessage: '',
      form: {
        account: '',
        password: ''
      }
    }
  },
  methods: {
    focusPassword () {
      const input = this.$refs.passwordInput
      if (input && typeof input.focus === 'function') input.focus()
    },
    async login () {
      if (this.loading) return
      const account = String(this.form.account || '').trim()
      const password = String(this.form.password || '')
      if (!account || !password) {
        this.errorMessage = '请输入账号和密码'
        return
      }

      this.loading = true
      this.errorMessage = ''
      try {
        const res = await this.$http.post('/h5/auth/passwordLogin', Qs.stringify({
          account: account,
          passwordHash: sha1(password)
        }))
        if (res.result !== '1' || !res.data || !res.data.accessToken) {
          const businessMessage = typeof res.data === 'string' ? res.data : ''
          throw new Error(businessMessage || res.desc || '登录失败')
        }
        setToken(res.data.accessToken)
        setAuthMeta({
          authMode: 'password',
          userId: res.data.userId || '',
          userName: res.data.userName || account,
          phone: res.data.phone || ''
        })
        this.goAfterLogin()
      } catch (error) {
        this.errorMessage = error.message || '登录失败，请稍后重试'
      } finally {
        this.loading = false
      }
    },
    goAfterLogin () {
      const redirect = String(this.$route.query.redirect || '')
      const target = redirect && redirect.charAt(0) === '/' && redirect.indexOf('/login') !== 0 ? redirect : '/home'
      this.$router.replace(target)
    }
  }
}
</script>

<style scoped>
.login-page { min-height: 100vh; padding: 58px 18px 30px; box-sizing: border-box; background: linear-gradient(180deg, #edf5ff 0, var(--wpc-bg) 260px); }
.login-panel { width: 100%; max-width: 430px; margin: 0 auto; padding: 26px 22px 22px; border: 1px solid #e2ebf5; border-radius: 16px; box-sizing: border-box; background: #fff; }
.login-brand { margin-bottom: 30px; display: flex; align-items: center; gap: 13px; }
.login-brand > i { width: 50px; height: 50px; flex: 0 0 50px; border-radius: 14px; display: grid; place-items: center; color: #fff; background: var(--wpc-primary); font-size: 29px; }
.login-brand b, .login-brand span { display: block; }
.login-brand b { color: var(--wpc-text); font-size: 19px; }
.login-brand span { margin-top: 4px; color: var(--wpc-text-muted); font-size: 12px; }
.login-panel /deep/ .ivu-form-item { margin-bottom: 20px; }
.login-panel /deep/ .ivu-form-item-label { padding-bottom: 8px; color: #475467; font-size: 14px; font-weight: 500; }
.login-panel /deep/ .ivu-input { height: 46px; padding-top: 10px; padding-bottom: 10px; border-color: #dfe3e8; border-radius: 8px; font-size: 16px; }
.login-panel /deep/ .ivu-input-prefix, .login-panel /deep/ .ivu-input-suffix { width: 38px; line-height: 46px; }
.login-panel /deep/ .ivu-input-with-prefix { padding-left: 38px; }
.login-panel /deep/ .ivu-input-with-suffix { padding-right: 38px; }
.password-toggle { cursor: pointer; }
.login-error { margin: -3px 0 16px; padding: 10px 12px; border: 1px solid #f2d3d6; border-radius: 8px; display: flex; align-items: flex-start; gap: 7px; color: #b5474f; background: #fff7f7; font-size: 13px; line-height: 1.6; }
.login-error > i { flex: 0 0 auto; margin-top: 1px; font-size: 18px; }
@media (max-width: 340px) {
  .login-page { padding: 34px 10px 20px; }
  .login-panel { padding-right: 16px; padding-left: 16px; }
  .login-brand { gap: 10px; }
  .login-brand b { font-size: 17px; }
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue